module.exports = __webpack_public_path__ + "img/suit-spade.df3ef2e8.svg";